<template>
  <div class="sovi-tyosopimus-page sovi-home">
    <router-link to="/" class="sovi-tyosopimus-page__logo">
      <sovi-logo :size="48" />
    </router-link>

    <v-menu offset-y>
      <template #activator="{ props }">
        <v-btn
          class="language-menu"
          size="default"
          color="#eca1c2"
          v-bind="props"
        >
          <template #prepend>
            <v-icon icon="mdi-web" />
          </template>

          {{ $i18n.locale.toUpperCase() }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="option in $i18n.availableLocales"
          :key="option"
          class="align-items-center"
          @click="onLocaleChange(option)"
        >
          <v-row align="center" no-gutters>
            {{ option.toUpperCase() }}
          </v-row>
        </v-list-item>
      </v-list>
    </v-menu>

    <sovi-content-nav />

    <!-- Hero / Intro section -->
    <sovi-home-card
      src="/images/tyosopimus-2.webp"
      background="/images/tyosopimus-1.webp"
      :title="t('heroTitle')"
      fixed
      style="padding-top: 100px"
    >
      <strong>{{ t('heroSubtitle') }}</strong>

      <p>{{ t('heroText1') }}</p>

      <p>{{ t('heroText2') }}</p>

      <p>{{ t('heroText3') }}</p>
    </sovi-home-card>

    <!-- Benefits section -->
    <sovi-home-card
      src="/images/tyosopimus-3.webp"
      :title="t('benefitsTitle')"
      flipped
    >
      <strong>{{ t('benefitsLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('benefit1') }}</li>

        <li>{{ t('benefit2') }}</li>

        <li>{{ t('benefit3') }}</li>

        <li>{{ t('benefit4') }}</li>

        <li>{{ t('benefit5') }}</li>

        <li>{{ t('benefit6') }}</li>
      </ul>

      <p>{{ t('benefitsNote') }}</p>
    </sovi-home-card>

    <!-- Recruitment speed section -->
    <sovi-home-card src="/images/content-1.webp" :title="t('recruitmentTitle')">
      <p>{{ t('recruitmentText1') }}</p>

      <p>{{ t('recruitmentText2') }}</p>

      <p>{{ t('recruitmentText3') }}</p>
    </sovi-home-card>

    <!-- Employee experience section -->
    <sovi-home-card
      src="/images/content-2.webp"
      :title="t('experienceTitle')"
      flipped
    >
      <strong>{{ t('experienceLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('experience1') }}</li>

        <li>{{ t('experience2') }}</li>

        <li>{{ t('experience3') }}</li>

        <li>{{ t('experience4') }}</li>
      </ul>

      <p>{{ t('experienceNote') }}</p>
    </sovi-home-card>

    <!-- Document management section -->
    <sovi-home-card src="/images/content-3.webp" :title="t('documentTitle')">
      <strong>{{ t('documentLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('document1') }}</li>

        <li>{{ t('document2') }}</li>

        <li>{{ t('document3') }}</li>

        <li>{{ t('document4') }}</li>

        <li>{{ t('document5') }}</li>
      </ul>

      <p>{{ t('documentNote') }}</p>
    </sovi-home-card>

    <!-- Contract types section -->
    <sovi-home-card
      src="/images/content-4.webp"
      :title="t('typesTitle')"
      flipped
    >
      <strong>{{ t('typesLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('type1') }}</li>

        <li>{{ t('type2') }}</li>

        <li>{{ t('type3') }}</li>

        <li>{{ t('type4') }}</li>

        <li>{{ t('type5') }}</li>

        <li>{{ t('type6') }}</li>

        <li>{{ t('type7') }}</li>

        <li>{{ t('type8') }}</li>

        <li>{{ t('type9') }}</li>

        <li>{{ t('type10') }}</li>
      </ul>

      <p>{{ t('typesNote') }}</p>
    </sovi-home-card>

    <!-- Process steps section -->
    <sovi-home-card src="/images/content-5.webp" :title="t('processTitle')">
      <strong>{{ t('processLead') }}</strong>

      <ol class="ms-6 list-decimal">
        <li>{{ t('step1') }}</li>

        <li>{{ t('step2') }}</li>

        <li>{{ t('step3') }}</li>

        <li>{{ t('step4') }}</li>

        <li>{{ t('step5') }}</li>

        <li>{{ t('step6') }}</li>
      </ol>

      <p>{{ t('processNote') }}</p>
    </sovi-home-card>

    <!-- Security section -->
    <sovi-home-card
      src="/images/content-6.webp"
      :title="t('securityTitle')"
      flipped
    >
      <p>{{ t('securityText1') }}</p>

      <p>{{ t('securityText2') }}</p>

      <p>{{ t('securityText3') }}</p>
    </sovi-home-card>

    <!-- HR efficiency section -->
    <sovi-home-card src="/images/content-23.webp" :title="t('hrTitle')">
      <strong>{{ t('hrLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('hr1') }}</li>

        <li>{{ t('hr2') }}</li>

        <li>{{ t('hr3') }}</li>

        <li>{{ t('hr4') }}</li>

        <li>{{ t('hr5') }}</li>

        <li>{{ t('hr6') }}</li>
      </ul>

      <p>{{ t('hrNote1') }}</p>

      <p>{{ t('hrNote2') }}</p>
    </sovi-home-card>

    <!-- Remote work section -->
    <sovi-home-card
      src="/images/sahkoinen-allekirjoitus-3.webp"
      :title="t('remoteTitle')"
      flipped
    >
      <p>{{ t('remoteText1') }}</p>

      <p>{{ t('remoteText2') }}</p>

      <ul class="ms-6 list-disc">
        <li>{{ t('remote1') }}</li>

        <li>{{ t('remote2') }}</li>

        <li>{{ t('remote3') }}</li>

        <li>{{ t('remote4') }}</li>

        <li>{{ t('remote5') }}</li>
      </ul>
    </sovi-home-card>

    <!-- Examples section -->
    <sovi-home-card src="/images/content-8.webp" :title="t('examplesTitle')">
      <strong>{{ t('example1Title') }}</strong>

      <p>{{ t('example1Text') }}</p>

      <strong>{{ t('example2Title') }}</strong>

      <p>{{ t('example2Text') }}</p>

      <strong>{{ t('example3Title') }}</strong>

      <p>{{ t('example3Text') }}</p>
    </sovi-home-card>

    <!-- Why Sovi section -->
    <sovi-home-card
      src="/images/content-9.webp"
      :title="t('whySoviTitle')"
      flipped
    >
      <p>{{ t('whySoviLead') }}</p>

      <strong>{{ t('whySoviTemplates') }}</strong>

      <p>{{ t('whySoviTemplatesText') }}</p>

      <strong>{{ t('whySoviManagement') }}</strong>

      <p>{{ t('whySoviManagementText') }}</p>

      <strong>{{ t('whySoviTracking') }}</strong>

      <p>{{ t('whySoviTrackingText') }}</p>

      <strong>{{ t('whySoviPricing') }}</strong>

      <p>{{ t('whySoviPricingText') }}</p>
    </sovi-home-card>

    <!-- Industries section -->
    <sovi-home-card src="/images/content-10.webp" :title="t('industriesTitle')">
      <strong>{{ t('industriesLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('industry1') }}</li>

        <li>{{ t('industry2') }}</li>

        <li>{{ t('industry3') }}</li>

        <li>{{ t('industry4') }}</li>

        <li>{{ t('industry5') }}</li>

        <li>{{ t('industry6') }}</li>

        <li>{{ t('industry7') }}</li>

        <li>{{ t('industry8') }}</li>

        <li>{{ t('industry9') }}</li>

        <li>{{ t('industry10') }}</li>
      </ul>

      <p>{{ t('industriesNote') }}</p>
    </sovi-home-card>

    <!-- Challenges section -->
    <sovi-home-card
      src="/images/content-11.webp"
      :title="t('challengesTitle')"
      flipped
    >
      <strong>{{ t('challengesLead') }}</strong>

      <ul class="ms-6 list-disc">
        <li>{{ t('challenge1') }}</li>

        <li>{{ t('challenge2') }}</li>

        <li>{{ t('challenge3') }}</li>

        <li>{{ t('challenge4') }}</li>

        <li>{{ t('challenge5') }}</li>
      </ul>

      <p>{{ t('challengesNote') }}</p>
    </sovi-home-card>

    <!-- FAQ section -->
    <sovi-home-card src="/images/content-7.webp" :title="t('faqTitle')">
      <strong>{{ t('faqQ1') }}</strong>

      <p>{{ t('faqA1') }}</p>

      <strong>{{ t('faqQ2') }}</strong>

      <p>{{ t('faqA2') }}</p>

      <strong>{{ t('faqQ3') }}</strong>

      <p>{{ t('faqA3') }}</p>

      <strong>{{ t('faqQ4') }}</strong>

      <p>{{ t('faqA4') }}</p>

      <strong>{{ t('faqQ5') }}</strong>

      <p>{{ t('faqA5') }}</p>

      <strong>{{ t('faqQ6') }}</strong>

      <p>{{ t('faqA6') }}</p>

      <template #button>
        <router-link
          to="/ukk"
          class="font-weight-medium text-decoration-underline text-black"
        >
          {{ t('faqLink') }} →
        </router-link>
      </template>
    </sovi-home-card>

    <!-- CTA section -->
    <sovi-home-card
      src="/images/content-13.webp"
      :title="t('ctaTitle')"
      flipped
    >
      <p>{{ t('ctaLead') }}</p>

      <ul class="ms-6 list-disc">
        <li>{{ t('cta1') }}</li>

        <li>{{ t('cta2') }}</li>

        <li>{{ t('cta3') }}</li>

        <li>{{ t('cta4') }}</li>

        <li>{{ t('cta5') }}</li>

        <li>{{ t('cta6') }}</li>
      </ul>

      <p>
        <strong>{{ t('ctaAction') }}</strong>
      </p>

      <template #button>
        <div style="display: grid; gap: 8px">
          <router-link
            to="/sahkoinen-allekirjoitus"
            class="font-weight-medium text-decoration-underline text-black"
          >
            {{ t('linkEsignature') }} →
          </router-link>

          <router-link
            to="/vuokrasopimuksen-sahkoinen-allekirjoitus"
            class="font-weight-medium text-decoration-underline text-black"
          >
            {{ t('linkRental') }} →
          </router-link>
        </div>
      </template>
    </sovi-home-card>

    <div class="sovi-tyosopimus-page__login">
      <sovi-home-login />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTheme } from 'vuetify';
import { definePage } from 'vue-router/auto';
import { useRouteMeta } from '@/composables/useRouteMeta';
import { useAuthorizationStore } from '@/stores/authorization';
import { loadRecaptcha } from '@/plugins/recaptcha';
import SoviHomeLogin from '@/components/home/SoviHomeLogin.vue';

definePage({
  meta: {
    hero: false,
    restricted: false,
    maxContainer: true,
  },
});

useRouteMeta({
  title:
    'Työsopimuksen sähköinen allekirjoitus – Nopea ja turvallinen tapa allekirjoittaa työsopimus | Sovi.fi',
  description:
    'Allekirjoita työsopimus sähköisesti nopeasti ja turvallisesti. Nopeuta rekrytointia, vähennä paperityötä ja hallitse työsopimukset helposti Sovi.fi-palvelulla.',
});

const { locale } = useI18n({ useScope: 'global' });

const { t } = useI18n();

const theme = useTheme();

const { isAuthorized } = useAuthorizationStore();

const onLocaleChange = (newLocale: string) => {
  locale.value = newLocale;
  localStorage.setItem('sovi-locale', newLocale);
};

onMounted(() => {
  document.getElementById('sovi-main')?.scrollTo(0, 0);
  window.scrollTo(0, 0);
  loadRecaptcha();

  const storedLocale = localStorage.getItem('sovi-locale');

  if (storedLocale && storedLocale !== locale.value) {
    locale.value = storedLocale;
  }

  theme.global.name.value = 'light';

  isAuthorized();
});
</script>

<style lang="scss">
.sovi-tyosopimus-page {
  position: relative;
  background-color: #fff;
  font-size: clamp(18px, 2vw, 22px);

  &__logo {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 2;
  }

  .language-menu {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 2;
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 15px 25px,
      rgba(0, 0, 0, 0.05) 0px 5px 10px;
  }

  .home-title {
    line-height: 1.3;

    @media (min-width: 768px) {
      line-height: 1.1;
    }
    --title-color: rgb(var(--v-theme-primary));

    &.alt {
      --title-color: #eca1c2;
    }

    &::first-letter {
      padding-bottom: 2px;
      box-shadow: inset 0 calc(-1 * clamp(4px, 0.5vw, 6px)) 0 0
        var(--title-color);
    }
  }

  &__login {
    overflow: hidden;

    .sovi-home__login {
      &::before,
      &::after {
        display: none;
      }
    }
    background-color: #fff;
    padding: clamp(32px, 5vw, 64px) clamp(16px, 5vw, 32px);

    .sovi-home__login-form {
      display: grid;
      gap: clamp(16px, 3vw, 32px);
      position: relative;
      z-index: 1;

      h1 {
        font-size: clamp(24px, 3vw, 32px);
      }
    }
  }
}
</style>

<i18n lang="json">
{
  "fi": {
    "heroTitle": "Työsopimuksen sähköinen allekirjoitus",
    "heroSubtitle": "Nopeuta rekrytointia ja vähennä hallinnollista työtä sähköisellä allekirjoituksella",
    "heroText1": "Rekrytointiprosessin viimeinen vaihe on usein ratkaiseva. Kun sopiva työntekijä on löytynyt, työsopimus halutaan saada allekirjoitettua mahdollisimman nopeasti, jotta työsuhde voidaan käynnistää ilman viivästyksiä. Perinteinen paperinen allekirjoitus voi kuitenkin hidastaa prosessia: sopimuksia tulostetaan, lähetetään sähköpostitse tai postitse, allekirjoitetaan käsin, skannataan ja palautetaan.",
    "heroText2": "Sähköinen allekirjoitus poistaa nämä ylimääräiset vaiheet. Työsopimus voidaan lähettää allekirjoitettavaksi heti, ja työntekijä voi hyväksyä sen tietokoneella, tabletilla tai puhelimella ajasta ja paikasta riippumatta.",
    "heroText3": "Sovi.fi tarjoaa yrityksille helppokäyttöisen sähköisen allekirjoitus- ja asiakirjahallintapalvelun, jonka avulla työsopimusten käsittely nopeutuu, dokumentit pysyvät järjestyksessä ja koko prosessi on sujuva sekä työnantajalle että työntekijälle.",
    "benefitsTitle": "Miksi allekirjoittaa työsopimus sähköisesti?",
    "benefitsLead": "Työsopimus on yksi yrityksen tärkeimmistä asiakirjoista. Sen laatiminen ja allekirjoittaminen on keskeinen osa henkilöstöhallintoa, ja samalla yksi yleisimmistä tilanteista, joissa sähköisestä allekirjoituksesta on merkittävää hyötyä. Kun työsopimus allekirjoitetaan sähköisesti:",
    "benefit1": "rekrytointi etenee nopeammin",
    "benefit2": "työntekijän aloitus ei viivästy",
    "benefit3": "sopimukset ovat helposti löydettävissä",
    "benefit4": "paperin käyttö vähenee",
    "benefit5": "hallinnollinen työ kevenee",
    "benefit6": "sopimusten seuranta helpottuu",
    "benefitsNote": "Erityisesti tilanteissa, joissa työntekijä asuu toisella paikkakunnalla tai aloittaa työn nopeasti, sähköinen allekirjoitus tuo huomattavan ajansäästön.",
    "recruitmentTitle": "Rekrytointi nopeutuu",
    "recruitmentText1": "Kilpailu osaavista työntekijöistä on kovaa. Kun sopiva henkilö löytyy, yrityksen kannattaa varmistaa, että työsopimus saadaan allekirjoitettua mahdollisimman nopeasti.",
    "recruitmentText2": "Sähköinen allekirjoitus mahdollistaa sen, että sopimus voidaan lähettää työntekijälle heti rekrytointipäätöksen jälkeen. Työntekijä voi allekirjoittaa asiakirjan saman tien ilman toimistokäyntiä tai tulostinta.",
    "recruitmentText3": "Nopeampi allekirjoitus vähentää riskiä, että rekrytointi viivästyy tai työntekijä ehtii hyväksyä toisen tarjouksen.",
    "experienceTitle": "Parempi työntekijäkokemus",
    "experienceLead": "Työsuhde alkaa jo ennen ensimmäistä työpäivää. Ensivaikutelma muodostuu siitä, kuinka sujuvasti rekrytointi ja sopimusprosessi etenevät. Kun työsopimus voidaan allekirjoittaa helposti verkossa:",
    "experience1": "työntekijä säästää aikaa",
    "experience2": "prosessi on selkeä",
    "experience3": "ylimääräisiä työvaiheita ei tarvita",
    "experience4": "asiakirjat löytyvät helposti myöhemminkin",
    "experienceNote": "Moderni digitaalinen allekirjoitus antaa yrityksestä ammattimaisen ja nykyaikaisen kuvan.",
    "documentTitle": "Työsopimukset pysyvät järjestyksessä",
    "documentLead": "Monessa yrityksessä työsopimuksia säilytetään useissa eri kansioissa, sähköposteissa tai verkkolevyillä. Tämä vaikeuttaa asiakirjojen löytämistä ja lisää riskiä, että sopimuksia katoaa tai niiden uusimmat versiot eivät ole helposti saatavilla. Kun työsopimukset hallitaan yhdessä järjestelmässä:",
    "document1": "kaikki asiakirjat löytyvät nopeasti",
    "document2": "versioiden hallinta helpottuu",
    "document3": "käyttöoikeuksia voidaan hallita",
    "document4": "dokumentit pysyvät järjestyksessä",
    "document5": "henkilöstöhallinto tehostuu",
    "documentNote": "Sovi.fi yhdistää sähköisen allekirjoituksen ja asiakirjahallinnan samaan palveluun, jolloin koko työsopimusprosessi voidaan hoitaa yhdestä paikasta.",
    "typesTitle": "Millaisia työsopimuksia voidaan allekirjoittaa sähköisesti?",
    "typesLead": "Sähköinen allekirjoitus soveltuu käytännössä kaikenlaisiin työsuhteisiin. Esimerkiksi:",
    "type1": "vakituinen työsopimus",
    "type2": "määräaikainen työsopimus",
    "type3": "osa-aikainen työsopimus",
    "type4": "kokoaikainen työsopimus",
    "type5": "harjoittelusopimus",
    "type6": "oppisopimukseen liittyvät asiakirjat",
    "type7": "johtajasopimus",
    "type8": "etätyösopimus",
    "type9": "työehtojen muutokset",
    "type10": "lisäykset ja liitteet",
    "typesNote": "Sama sähköinen allekirjoitusprosessi toimii riippumatta siitä, onko kyseessä ensimmäinen työsopimus vai olemassa olevan sopimuksen päivittäminen.",
    "processTitle": "Näin sähköinen työsopimus toimii",
    "processLead": "Työsopimuksen sähköinen allekirjoitus on yksinkertainen prosessi:",
    "step1": "Työsopimus laaditaan tai ladataan Sovi.fi-palveluun.",
    "step2": "Työntekijän tiedot lisätään.",
    "step3": "Allekirjoituspyyntö lähetetään sähköisesti.",
    "step4": "Työntekijä avaa pyynnön ja allekirjoittaa sopimuksen.",
    "step5": "Työnantaja saa ilmoituksen valmiista allekirjoituksesta.",
    "step6": "Valmis työsopimus tallentuu turvallisesti myöhempää käyttöä varten.",
    "processNote": "Koko prosessi voidaan usein hoitaa saman työpäivän aikana, mikä nopeuttaa merkittävästi rekrytointia ja vähentää hallinnollista työtä.",
    "securityTitle": "Työsopimuksen sähköinen allekirjoitus on turvallinen ja luotettava",
    "securityText1": "Työsopimus sisältää usein henkilötietoja, palkkausta koskevia tietoja, työehtoja ja muita luottamuksellisia tietoja. Siksi allekirjoitusprosessin turvallisuus on yksi tärkeimmistä vaatimuksista.",
    "securityText2": "Sähköinen allekirjoitus auttaa varmistamaan, että sopimus käsitellään hallitusti koko sen elinkaaren ajan. Samalla allekirjoitusprosessista jää tapahtumatiedot, joiden avulla voidaan myöhemmin todentaa, milloin asiakirja on lähetetty, hyväksytty ja allekirjoitettu.",
    "securityText3": "Kun työsopimukset säilytetään keskitetysti, myös niiden hallinta helpottuu. Yrityksen henkilöstöhallinto löytää tarvittavat asiakirjat nopeasti ilman aikaa vievää sähköpostien tai paperiarkistojen läpikäyntiä.",
    "hrTitle": "Henkilöstöhallinnon tehokkuus paranee",
    "hrLead": "HR-tiimit käsittelevät usein suuren määrän asiakirjoja:",
    "hr1": "työsopimuksia",
    "hr2": "salassapitosopimuksia",
    "hr3": "etätyösopimuksia",
    "hr4": "työehtojen muutoksia",
    "hr5": "perehdytysasiakirjoja",
    "hr6": "henkilöstöohjeiden kuittauksia",
    "hrNote1": "Kun allekirjoitus tapahtuu sähköisesti, samat työvaiheet voidaan toistaa tehokkaasti ilman manuaalista paperityötä.",
    "hrNote2": "Toistuvia sopimuksia varten voidaan hyödyntää valmiita asiakirjamalleja, jolloin uuden työsopimuksen luominen vie vain muutaman minuutin. Tämä vähentää virheiden mahdollisuutta ja varmistaa, että käytössä on aina ajantasainen sopimuspohja.",
    "remoteTitle": "Sähköinen allekirjoitus tukee etätyötä",
    "remoteText1": "Monessa organisaatiossa rekrytoitavat työntekijät eivät käy toimistolla ennen ensimmäistä työpäiväänsä. Työ voi alkaa kokonaan etänä tai toiselta paikkakunnalta.",
    "remoteText2": "Sähköinen allekirjoitus mahdollistaa sen, että työsopimus voidaan hyväksyä turvallisesti ilman fyysistä tapaamista. Tämä tekee rekrytoinnista joustavampaa ja nopeampaa sekä työnantajalle että työntekijälle. Erityisen hyödyllinen sähköinen allekirjoitus on esimerkiksi:",
    "remote1": "valtakunnallisesti toimiville yrityksille",
    "remote2": "henkilöstövuokrausyrityksille",
    "remote3": "konsulttiyrityksille",
    "remote4": "IT-yrityksille",
    "remote5": "kansainvälisiä työntekijöitä rekrytoiville organisaatioille",
    "examplesTitle": "Käytännön esimerkkejä",
    "example1Title": "Esimerkki 1: nopea rekrytointi",
    "example1Text": "Yritys löytää sopivan työntekijän maanantaina iltapäivällä. Työsopimus laaditaan saman tien ja lähetetään sähköisesti allekirjoitettavaksi. Työntekijä hyväksyy sopimuksen puhelimellaan illalla, ja rekrytointi voidaan vahvistaa heti seuraavana aamuna. Perinteisellä paperiprosessilla sama olisi voinut kestää useita päiviä.",
    "example2Title": "Esimerkki 2: kausityöntekijöiden palkkaaminen",
    "example2Text": "Yritys rekrytoi kesäksi kymmeniä työntekijöitä. Valmiiden työsopimusmallien ansiosta jokainen sopimus voidaan luoda nopeasti, lähettää sähköisesti ja arkistoida automaattisesti samaan järjestelmään. Hallinnollinen työ vähenee merkittävästi verrattuna paperisiin sopimuksiin.",
    "example3Title": "Esimerkki 3: muutos työsuhteeseen",
    "example3Text": "Työntekijän työaika muuttuu osa-aikaisesta kokoaikaiseksi. Uutta paperisopimusta ei tarvitse tulostaa tai lähettää postitse, vaan muutossopimus voidaan laatia ja allekirjoittaa sähköisesti saman päivän aikana.",
    "whySoviTitle": "Miksi yritykset valitsevat Sovi.fi:n?",
    "whySoviLead": "Työsopimusten hallinnassa tärkeintä on, että ratkaisu on helppokäyttöinen, turvallinen ja sopii yrityksen arkeen. Sovi.fi tarjoaa tähän käytännöllisen kokonaisuuden.",
    "whySoviTemplates": "Valmiit asiakirjamallit",
    "whySoviTemplatesText": "Toistuvasti käytettävät työsopimukset voidaan tallentaa valmiiksi. Tämä nopeuttaa rekrytointia ja vähentää virheitä.",
    "whySoviManagement": "Keskitetty asiakirjahallinta",
    "whySoviManagementText": "Kaikki allekirjoitetut työsopimukset löytyvät yhdestä paikasta. Asiakirjojen hakeminen, järjestäminen ja hallinta on vaivatonta.",
    "whySoviTracking": "Allekirjoitusten seuranta",
    "whySoviTrackingText": "Voit nähdä, onko sopimus avattu, odottaako se allekirjoitusta vai onko prosessi valmis. Tämä vähentää tarvetta muistutusviesteille ja nopeuttaa asioiden etenemistä.",
    "whySoviPricing": "Joustava hinnoittelu",
    "whySoviPricingText": "Yrityksen ei tarvitse maksaa suurta kuukausimaksua, jos allekirjoituksia tehdään vain satunnaisesti. Käytön mukaan hinnoiteltu palvelu sopii myös pienille yrityksille ja kasvaville organisaatioille.",
    "industriesTitle": "Millaiset yritykset hyötyvät eniten?",
    "industriesLead": "Sähköinen työsopimus sopii lähes kaikille toimialoille, mutta erityisen paljon hyötyä siitä saavat:",
    "industry1": "henkilöstöpalveluyritykset",
    "industry2": "rakennusalan yritykset",
    "industry3": "teollisuusyritykset",
    "industry4": "ravintolat",
    "industry5": "vähittäiskauppa",
    "industry6": "kiinteistöala",
    "industry7": "IT- ja ohjelmistoyritykset",
    "industry8": "asiantuntijapalvelut",
    "industry9": "terveydenhuolto",
    "industry10": "julkiset organisaatiot",
    "industriesNote": "Yhteistä näille toimialoille on suuri määrä sopimuksia sekä tarve hoitaa ne nopeasti ja luotettavasti.",
    "challengesTitle": "Tyypilliset haasteet, jotka sähköinen allekirjoitus ratkaisee",
    "challengesLead": "Monissa yrityksissä kohdataan samoja ongelmia:",
    "challenge1": "sopimukset viipyvät allekirjoitettavana",
    "challenge2": "dokumentteja katoaa sähköposteihin",
    "challenge3": "oikean version löytäminen vie aikaa",
    "challenge4": "paperiarkistot kasvavat jatkuvasti",
    "challenge5": "HR käyttää paljon aikaa hallinnollisiin tehtäviin",
    "challengesNote": "Sähköinen allekirjoitus ja keskitetty asiakirjahallinta vähentävät näitä haasteita ja vapauttavat aikaa henkilöstön tukemiseen sekä liiketoiminnan kehittämiseen.",
    "faqTitle": "Usein kysytyt kysymykset työsopimuksen sähköisestä allekirjoituksesta",
    "faqQ1": "Voiko työsopimuksen allekirjoittaa sähköisesti?",
    "faqA1": "Kyllä. Työsopimus voidaan useimmissa tilanteissa allekirjoittaa sähköisesti. Sähköinen allekirjoitus nopeuttaa rekrytointia, vähentää paperityötä ja helpottaa sopimusten hallintaa.",
    "faqQ2": "Onko sähköisesti allekirjoitettu työsopimus pätevä?",
    "faqA2": "Kyllä. Oikein toteutettu sähköinen allekirjoitus on oikeudellisesti sitova useimmissa työsopimuksissa. Mahdolliset erityistilanteet kannattaa kuitenkin arvioida tapauskohtaisesti voimassa olevan lainsäädännön mukaisesti.",
    "faqQ3": "Voiko työntekijä allekirjoittaa sopimuksen puhelimella?",
    "faqA3": "Kyllä. Työntekijä voi allekirjoittaa työsopimuksen tietokoneella, tabletilla tai älypuhelimella. Tämä on erityisen hyödyllistä etärekrytoinneissa ja silloin, kun työntekijä ei käy toimistolla ennen työn alkamista.",
    "faqQ4": "Kuinka nopeasti sähköinen työsopimus voidaan allekirjoittaa?",
    "faqA4": "Parhaimmillaan muutamassa minuutissa. Kun työnantaja lähettää allekirjoituspyynnön, työntekijä voi hyväksyä sopimuksen heti saatuaan sen.",
    "faqQ5": "Voidaanko myös työsopimuksen muutokset allekirjoittaa sähköisesti?",
    "faqA5": "Kyllä. Esimerkiksi työajan muutokset, palkankorotukset, määräaikaisuuden jatkaminen, etätyösopimukset ja muut sopimusmuutokset voidaan käsitellä samalla sähköisellä allekirjoitusprosessilla.",
    "faqQ6": "Mitä hyötyä sähköisestä allekirjoituksesta on henkilöstöhallinnolle?",
    "faqA6": "Sähköinen allekirjoitus vähentää manuaalista työtä, nopeuttaa rekrytointeja, helpottaa asiakirjojen hallintaa ja parantaa sopimusprosessien läpinäkyvyyttä. Samalla HR-tiimi voi käyttää enemmän aikaa henkilöstön kehittämiseen ja vähemmän aikaa hallinnollisiin rutiineihin.",
    "faqLink": "Katso kaikki usein kysytyt kysymykset",
    "ctaTitle": "Aloita työsopimusten sähköinen allekirjoitus",
    "ctaLead": "Kun työsopimusten allekirjoittaminen siirretään sähköiseen muotoon, yritys säästää aikaa, vähentää virheitä ja parantaa työntekijäkokemusta heti rekrytoinnin alusta lähtien. Sovi.fi tarjoaa modernin ratkaisun, jonka avulla voit:",
    "cta1": "lähettää työsopimuksia allekirjoitettavaksi nopeasti",
    "cta2": "hallita sopimuksia yhdessä paikassa",
    "cta3": "hyödyntää valmiita sopimuspohjia",
    "cta4": "seurata allekirjoitusten etenemistä",
    "cta5": "tehostaa koko henkilöstöhallinnon toimintaa",
    "cta6": "säilyttää asiakirjat turvallisesti",
    "ctaAction": "Luo maksuton tili ja lähetä ensimmäinen työsopimus allekirjoitettavaksi muutamassa minuutissa.",
    "linkEsignature": "Sähköinen allekirjoitus",
    "linkRental": "Vuokrasopimuksen sähköinen allekirjoitus"
  },
  "en": {
    "heroTitle": "Electronic signature for employment contracts",
    "heroSubtitle": "Speed up recruitment and reduce administrative work with electronic signatures",
    "heroText1": "The final stage of the recruitment process is often decisive. Once the right candidate is found, the employment contract needs to be signed as quickly as possible so work can begin without delay. Traditional paper-based signing can slow things down: contracts are printed, sent by email or post, signed by hand, scanned, and returned.",
    "heroText2": "Electronic signatures eliminate these unnecessary steps. The employment contract can be sent for signing immediately, and the employee can approve it on a computer, tablet, or phone — regardless of time or location.",
    "heroText3": "Sovi.fi offers businesses an easy-to-use electronic signature and document management service that speeds up employment contract processing, keeps documents organized, and makes the entire process smooth for both employer and employee.",
    "benefitsTitle": "Why sign employment contracts electronically?",
    "benefitsLead": "The employment contract is one of a company's most important documents. Drafting and signing it is a key part of HR management, and one of the most common situations where electronic signatures provide significant benefits. When an employment contract is signed electronically:",
    "benefit1": "recruitment moves forward faster",
    "benefit2": "the employee's start date isn't delayed",
    "benefit3": "contracts are easy to find",
    "benefit4": "paper usage is reduced",
    "benefit5": "administrative workload decreases",
    "benefit6": "contract tracking becomes easier",
    "benefitsNote": "Especially in situations where the employee lives in another city or starts work quickly, electronic signatures save considerable time.",
    "recruitmentTitle": "Faster recruitment",
    "recruitmentText1": "Competition for skilled workers is fierce. Once the right person is found, companies should ensure the employment contract gets signed as quickly as possible.",
    "recruitmentText2": "Electronic signatures make it possible to send the contract to the employee immediately after the hiring decision. The employee can sign the document right away without visiting the office or needing a printer.",
    "recruitmentText3": "Faster signing reduces the risk of recruitment being delayed or the employee accepting another offer in the meantime.",
    "experienceTitle": "A better employee experience",
    "experienceLead": "The employment relationship begins before the first working day. The first impression is shaped by how smoothly the recruitment and contract process proceeds. When the employment contract can be signed easily online:",
    "experience1": "the employee saves time",
    "experience2": "the process is clear and straightforward",
    "experience3": "no unnecessary extra steps are needed",
    "experience4": "documents are easy to find later",
    "experienceNote": "A modern digital signature gives the company a professional and contemporary image.",
    "documentTitle": "Employment contracts stay organized",
    "documentLead": "In many companies, employment contracts are stored in various folders, emails, or network drives. This makes documents hard to find and increases the risk of contracts being lost or the latest versions not being readily available. When employment contracts are managed in one system:",
    "document1": "all documents can be found quickly",
    "document2": "version management becomes easier",
    "document3": "access rights can be controlled",
    "document4": "documents stay organized",
    "document5": "HR operations become more efficient",
    "documentNote": "Sovi.fi combines electronic signatures and document management in the same service, allowing the entire employment contract process to be handled in one place.",
    "typesTitle": "What types of employment contracts can be signed electronically?",
    "typesLead": "Electronic signatures are suitable for practically all types of employment relationships. For example:",
    "type1": "permanent employment contracts",
    "type2": "fixed-term employment contracts",
    "type3": "part-time employment contracts",
    "type4": "full-time employment contracts",
    "type5": "internship agreements",
    "type6": "apprenticeship-related documents",
    "type7": "executive contracts",
    "type8": "remote work agreements",
    "type9": "changes to employment terms",
    "type10": "amendments and appendices",
    "typesNote": "The same electronic signing process works regardless of whether it's a first employment contract or an update to an existing agreement.",
    "processTitle": "How electronic employment contracts work",
    "processLead": "Signing an employment contract electronically is a simple process:",
    "step1": "The employment contract is drafted or uploaded to Sovi.fi.",
    "step2": "The employee's details are added.",
    "step3": "A signature request is sent electronically.",
    "step4": "The employee opens the request and signs the contract.",
    "step5": "The employer receives a notification when the signature is complete.",
    "step6": "The signed employment contract is securely stored for future reference.",
    "processNote": "The entire process can often be completed within the same working day, significantly speeding up recruitment and reducing administrative work.",
    "securityTitle": "Electronic signing of employment contracts is secure and reliable",
    "securityText1": "Employment contracts often contain personal information, salary details, employment terms, and other confidential data. That's why the security of the signing process is one of the most important requirements.",
    "securityText2": "Electronic signatures help ensure the contract is handled in a controlled manner throughout its lifecycle. At the same time, the signing process creates an audit trail that can later verify when a document was sent, approved, and signed.",
    "securityText3": "When employment contracts are stored centrally, managing them also becomes easier. The company's HR team can quickly find the documents they need without time-consuming searches through emails or paper archives.",
    "hrTitle": "Improved HR efficiency",
    "hrLead": "HR teams often handle a large volume of documents:",
    "hr1": "employment contracts",
    "hr2": "non-disclosure agreements",
    "hr3": "remote work agreements",
    "hr4": "changes to employment terms",
    "hr5": "onboarding documents",
    "hr6": "acknowledgements of personnel policies",
    "hrNote1": "When signing is done electronically, the same steps can be repeated efficiently without manual paperwork.",
    "hrNote2": "For recurring contracts, ready-made document templates can be used, making the creation of a new employment contract take just a few minutes. This reduces the chance of errors and ensures that an up-to-date contract template is always in use.",
    "remoteTitle": "Electronic signatures support remote work",
    "remoteText1": "In many organizations, new hires don't visit the office before their first working day. Work may begin entirely remotely or from another location.",
    "remoteText2": "Electronic signatures make it possible to approve the employment contract securely without a physical meeting. This makes recruitment more flexible and faster for both employer and employee. Electronic signatures are particularly useful for:",
    "remote1": "companies operating nationwide",
    "remote2": "staffing agencies",
    "remote3": "consulting firms",
    "remote4": "IT companies",
    "remote5": "organizations recruiting international employees",
    "examplesTitle": "Practical examples",
    "example1Title": "Example 1: Fast recruitment",
    "example1Text": "A company finds a suitable employee on Monday afternoon. The employment contract is drafted immediately and sent electronically for signing. The employee approves the contract on their phone that evening, and the recruitment can be confirmed first thing the next morning. With a traditional paper process, the same could have taken several days.",
    "example2Title": "Example 2: Hiring seasonal workers",
    "example2Text": "A company recruits dozens of workers for the summer. Thanks to ready-made contract templates, each contract can be created quickly, sent electronically, and automatically archived in the same system. Administrative work is significantly reduced compared to paper contracts.",
    "example3Title": "Example 3: Changes to employment terms",
    "example3Text": "An employee's working hours change from part-time to full-time. There's no need to print or mail a new paper contract — the amendment can be drafted and signed electronically on the same day.",
    "whySoviTitle": "Why do companies choose Sovi.fi?",
    "whySoviLead": "When managing employment contracts, the most important thing is that the solution is easy to use, secure, and fits into the company's daily operations. Sovi.fi offers a practical package for this.",
    "whySoviTemplates": "Ready-made document templates",
    "whySoviTemplatesText": "Frequently used employment contracts can be saved as templates. This speeds up recruitment and reduces errors.",
    "whySoviManagement": "Centralized document management",
    "whySoviManagementText": "All signed employment contracts can be found in one place. Searching, organizing, and managing documents is effortless.",
    "whySoviTracking": "Signature tracking",
    "whySoviTrackingText": "You can see whether a contract has been opened, is awaiting a signature, or has been completed. This reduces the need for reminder messages and speeds up progress.",
    "whySoviPricing": "Flexible pricing",
    "whySoviPricingText": "Companies don't need to pay a large monthly fee if signatures are only needed occasionally. A pay-per-use service suits small businesses and growing organizations too.",
    "industriesTitle": "Which businesses benefit the most?",
    "industriesLead": "Electronic employment contracts are suitable for nearly every industry, but the following benefit especially:",
    "industry1": "staffing agencies",
    "industry2": "construction companies",
    "industry3": "manufacturing companies",
    "industry4": "restaurants",
    "industry5": "retail",
    "industry6": "real estate",
    "industry7": "IT and software companies",
    "industry8": "professional services",
    "industry9": "healthcare",
    "industry10": "public sector organizations",
    "industriesNote": "What these industries have in common is a high volume of contracts and the need to handle them quickly and reliably.",
    "challengesTitle": "Common challenges that electronic signatures solve",
    "challengesLead": "Many companies face the same problems:",
    "challenge1": "contracts are stuck waiting for signatures",
    "challenge2": "documents get lost in emails",
    "challenge3": "finding the right version takes time",
    "challenge4": "paper archives keep growing",
    "challenge5": "HR spends too much time on administrative tasks",
    "challengesNote": "Electronic signatures and centralized document management reduce these challenges and free up time for supporting employees and growing the business.",
    "faqTitle": "Frequently asked questions about electronic signing of employment contracts",
    "faqQ1": "Can an employment contract be signed electronically?",
    "faqA1": "Yes. In most cases, employment contracts can be signed electronically. Electronic signatures speed up recruitment, reduce paperwork, and make contract management easier.",
    "faqQ2": "Is an electronically signed employment contract legally valid?",
    "faqA2": "Yes. A properly implemented electronic signature is legally binding for most employment contracts. However, any special circumstances should be evaluated on a case-by-case basis in accordance with applicable legislation.",
    "faqQ3": "Can the employee sign the contract on their phone?",
    "faqA3": "Yes. The employee can sign the employment contract on a computer, tablet, or smartphone. This is especially useful for remote recruitment and when the employee doesn't visit the office before starting work.",
    "faqQ4": "How quickly can an electronic employment contract be signed?",
    "faqA4": "In as little as a few minutes. Once the employer sends the signature request, the employee can approve the contract as soon as they receive it.",
    "faqQ5": "Can changes to employment contracts also be signed electronically?",
    "faqA5": "Yes. For example, changes to working hours, salary increases, extensions of fixed-term contracts, remote work agreements, and other contract amendments can all be handled with the same electronic signing process.",
    "faqQ6": "What are the benefits of electronic signatures for HR?",
    "faqA6": "Electronic signatures reduce manual work, speed up recruitment, make document management easier, and improve transparency in contract processes. At the same time, the HR team can spend more time on employee development and less on administrative routines.",
    "faqLink": "View all frequently asked questions",
    "ctaTitle": "Start signing employment contracts electronically",
    "ctaLead": "When employment contract signing goes digital, companies save time, reduce errors, and improve the employee experience from the very start of the recruitment process. Sovi.fi offers a modern solution that lets you:",
    "cta1": "send employment contracts for signing quickly",
    "cta2": "manage contracts in one place",
    "cta3": "use ready-made contract templates",
    "cta4": "track signature progress",
    "cta5": "streamline your entire HR operations",
    "cta6": "store documents securely",
    "ctaAction": "Create a free account and send your first employment contract for signing in just a few minutes.",
    "linkEsignature": "Electronic signature",
    "linkRental": "Electronic signature for rental agreements"
  }
}
</i18n>
